import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { VCStartPageComponent } from './virtual-consultation-start-page/virtual-consultation-start-page.component';
import { VCProgressCheckupComponent } from './virtual-consultation-progress-checkup/virtual-consultation-progress-checkup.component';
import { VCRetainerCheckupComponent } from './virtual-consultation-retainer-checkup/virtual-consultation-retainer-checkup.component';
import { VCPhotoUploadComponent } from './virtual-consultation-photo-upload/virtual-consultation-photo-upload.component';
import { VCPatientDetailsComponent } from './virtual-consultation-patient-details/virtual-consultation-patient-details.component';
import { VCSuccessPageComponent } from './virtual-consultation-success-page/virtual-consultation-success-page.component';
import { VCNewPatientComponent} from './virtual-consultation-new-patient/virtual-consultation-new-patient.component'
import { VCEmergencyCheckupComponent } from "./virtual-consultation-emergency-checkup/virtual-consultation-emergency-checkup.component";

const appRoutes: Routes = [
    { path: 'vc-start/:token', component: VCStartPageComponent },
    { path: 'vc-progress-checkup', component:VCProgressCheckupComponent },
    { path: 'vc-retainer-checkup', component:VCRetainerCheckupComponent },
    { path: 'vc-photo-upload', component:VCPhotoUploadComponent },
    { path: 'vc-patient-details', component:VCPatientDetailsComponent },
    { path: 'vc-success', component:VCSuccessPageComponent },
    { path: 'vc-new-consultation', component:VCNewPatientComponent},
    { path: 'vc-emergency-checkup', component: VCEmergencyCheckupComponent },
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes)
    ],
    exports: [
        RouterModule
    ]
})

export class VirtualConsultationRoutingModule { }



// @NgModule({
//   imports: [
//     RouterModule.forRoot(appRoutes, {preloadingStrategy: PreloadAllModules})
//   ],
//   exports: [
//     RouterModule
//   ]
// })
// export class PracticeAppRoutingModule { }
